<template>
  <div class="modal-wrapper">
    <div class="modal" :class="{ 'modal--report': isComingFromReport }">
      <div class="modal-header">
        <div class="new-input">
          <span class="mck">N</span>
          <input
            type="text"
            placeholder="Търсене"
            v-model="searchMechanizations"
          />
        </div>
        <span class="mck modal-close" @click="close()">F</span>
        <div class="btns-select" v-if="isComingFromReport">
          <button
            class="btn btn-select"
            @click="filterByPart = ''"
            v-if="filterByPart"
          >
            <span class="mck">e</span>
            Всички дейности
          </button>
          <button
            class="btn btn-select"
            @click="mechanizationMode = !mechanizationMode"
            v-else
          >
            <span class="mck2">r</span>
            Изглед по {{ mechanizationMode ? "част" : "механизация" }}
          </button>
          <button class="btn btn-select" @click="isEditItemWithPartOpen = true">
            <span class="mck">L</span>
            Нова механизация
          </button>
          <button
            class="btn btn-select"
            @click="toggleMechanizations(true)"
            :disabled="!mechanizationMode"
          >
            <span class="mck">W</span>
            Всички
          </button>
          <button
            class="btn btn-select"
            @click="toggleMechanizations(false)"
            :disabled="!mechanizationMode"
          >
            <span class="mck">X</span>
            Никой
          </button>
        </div>
      </div>
      <div class="modal-content" v-if="!isComingFromReport">
        <div
          v-if="!mechanizations.length"
          class="modal-content-template"
          @click="triggerFileInput()"
        >
          <img
            class="modal-content-template-img"
            src="../../assets/img/help_rentmech.svg"
            alt="Структура на таблицата"
            v-if="rented"
          />
          <img
            class="modal-content-template-img"
            src="../../assets/img/help_mech.svg"
            alt="Структура на таблицата"
            v-else
          />
        </div>
        <div
          class="modal-content-item with-edit"
          v-for="(mechanization, index) in filteredMechanizations"
          :key="`mechanizationModal-${index}-${mechanization.name}`"
          :class="{
            'modal-content-check-additional': mechanization.isAdditional,
          }"
          :title="mechanization.name"
        >
          <p>
            <span>
              {{ mechanization.name }}
              <template class="transparentish" v-if="rented">
                ({{ mechanization.landlord }})
              </template>
            </span>
            <span class="transparentish">{{ mechanization.part }}</span>
            <span class="transparentish"
              >{{ mechanization.price }} €/{{ mechanization.unit }},
              {{ mechanization.quantity }} {{ mechanization.unit }}
            </span>
          </p>
          <span class="mck edit" @click="editMechanization(index)" title
            >c</span
          >
          <span class="mck" @click="deleteMechanization(index)" title>b</span>
        </div>
        <!-- NO RESULTS -->
        <p
          class="modal-content-no-results"
          v-if="mechanizations.length && !filteredMechanizations.length"
        >
          Няма намерени резултати за '
          <strong>{{ this.searchMechanizations }}</strong
          >'
        </p>
      </div>
      <div class="modal-content" v-else>
        <template v-if="mechanizationMode">
          <div
            class="modal-content-check"
            v-for="(mechanization, index) in filteredMechanizations"
            :key="`addMechanizations-${index}-${mechanization._id}`"
            :class="{
              'modal-content-check-additional': mechanization.isAdditional,
              'modal-content-check-planned': mechanization.isPlanned,
            }"
            :title="mechanization.name"
          >
            <!-- 'modal-content-check-disabled': mechanization.isPlanned, -->
            <label class="checkbox-wrapper">
              <p>
                <span>
                  {{ mechanization.name }}
                  <template class="transparentish" v-if="rented">
                    ({{ mechanization.landlord }})
                  </template>
                </span>
                <!-- <span class="transparentish">{{ mechanization.part }}</span> -->
                <span class="transparentish"
                  >{{ mechanization.price }} €/{{ mechanization.unit }},
                  {{ mechanization.quantity }} {{ mechanization.unit }}
                </span>
              </p>
              <input
                type="checkbox"
                :id="mechanization._id"
                v-model="mechanization.isSelected"
              />
              <!-- :disabled="mechanization.isPlanned" -->
              <span class="checkmark"></span>
            </label>
            <template v-if="getAvailableParts(mechanization._id)">
              <div
                class="select-wrapper"
                v-if="getAvailableParts(mechanization._id).length"
              >
                <select
                  v-model="mechanization.part"
                  :class="{ 'select-grey': mechanization.part === '' }"
                  @change="updateMechanization(index)"
                >
                  <!-- :disabled="mechanization.isPlanned" -->
                  <option value disabled selected hidden>
                    Асоциирай към част
                  </option>
                  <!-- <option value v-if="mechanization.part">Премахни част</option> -->
                  <option
                    v-for="(p, j) in getAvailableParts(mechanization._id)"
                    :value="p"
                    :key="`${mechanization._id}-p-${j}`"
                  >
                    {{ p }}
                  </option>
                </select>
              </div>
            </template>
          </div>
        </template>
        <template v-else>
          <p
            class="select-p"
            v-for="(p, i) in parts"
            :key="`selectPart-${i}`"
            @click="(filterByPart = p), (mechanizationMode = true)"
          >
            {{ p }}
          </p>
        </template>
        <!-- NO RESULTS -->
        <p
          class="modal-content-no-results"
          v-if="mechanizations.length && !filteredMechanizations.length"
        >
          Няма намерени резултати за '
          <strong>{{ this.searchMechanizations }}</strong
          >'
        </p>
      </div>
      <div class="modal-footer">
        <div class="btns">
          <button
            class="btn btn-excel"
            @click="triggerFileInput()"
            v-if="!isComingFromReport"
          >
            <span class="mck">E</span>
            Добави файл
          </button>
          <input
            ref="uploadMechanizations"
            class="input-hide"
            type="file"
            @change="handleFile"
          />
          <!--  -->
          <button class="btn btn-new" @click="save()">
            <span class="mck">Y</span>
            Запази
          </button>
        </div>
      </div>
    </div>
    <EditItemWithPart
      v-if="isEditItemWithPartOpen"
      :type="rented ? 'rentedMechanization' : 'mechanization'"
      :obj="mechanizations[selectedIndex]"
      :parts="parts"
      @create="handleAdd"
      @edit="handleEditMechanization"
      @close="closeEditItemWithPartModal"
    />
  </div>
</template>

<script>
import * as XLSX from 'xlsx';
import EditItemWithPart from "./EditItemWithPart";
export default {
  components: {
    EditItemWithPart,
  },
  props: [
    "incomingMechanizations",
    "reportedMechanizations",
    "isComingFromReport",
    "companyId",
    "projectId",
    "objectId",
    "newestMechanization",
    "toggleImport",
    "parts",
    "rented",
  ],
  watch: {
    incomingMechanizations() {
      this.initMechanizations();
    },
  },
  data() {
    return {
      isEditItemWithPartOpen: false,
      selectedIndex: null,
      mechanizations: [],
      searchMechanizations: "",
      mechanizationMode: true,
      filterByPart: "",
    };
  },
  computed: {
    filteredMechanizations() {
      return this.filterMechanizations();
    },
  },
  methods: {
    triggerFileInput() {
      this.$refs.uploadMechanizations.click();
    },
    // EXCEL FILE TO JSON
    handleFile(e) {
      let rABS = true; // true: readAsBinaryString ; false: readAsArrayBuffer
      const files = e.target.files;
      const f = files[0];
      if (f.name.match(`.(xls|XLS|xlsx|XLSX)$`)) {
        const reader = new FileReader();
        reader.onload = (e) => {
          let data = e.target.result;
          if (!rABS) data = new Uint8Array(data);
          const workbook = XLSX.read(data, { type: rABS ? "binary" : "array" });

          /* DO SOMETHING WITH workbook HERE */
          const rows = this.workbookToJSON(workbook);
          // SHEET
          for (let row in rows) {
            const keys = Object.keys(rows[row][0]);
            for (let i = 0; i < keys.length; i++) {
              // ||
              // keys[i].toLowerCase().includes('мерна единица')
              if (
                !(
                  keys[i].toLowerCase().includes("име") ||
                  keys[i].toLowerCase().includes("ед. цена") ||
                  keys[i].toLowerCase().includes("цена") ||
                  keys[i].toLowerCase().includes("част") ||
                  keys[i].toLowerCase().includes("количество") ||
                  keys[i].toLowerCase().includes("к-во") ||
                  keys[i].toLowerCase().includes("наемодател")
                )
              ) {
                this.$snotify.error(
                  this.rented
                    ? "Таблицата трябва да има заглавен ред с Име / Цена / Част / Количество / Наемодател"
                    : "Таблицата трябва да има заглавен ред с Име / Цена / Част / Количество"
                );
                return;
              }
            }
            // ROW OBJECT
            let duplicates = 0;
            for (let item in rows[row]) {
              // // check for duplicate
              // const i = this.mechanizations
              //   .map((m) => m.name)
              //   .indexOf(rows[row][item][Object.keys(rows[row][item])[0]]);
              // if (i > -1) {
              //   // if there's one compare the units also and if same go to next iteration and increment counter
              //   if (
              //     this.mechanizations[i].price ===
              //     (rows[row][item][Object.keys(rows[row][item])[1]] || 0)
              //   ) {
              //     duplicates++;
              //     continue;
              //   }
              // }
              // ROW DATA
              const m = {
                name: rows[row][item][Object.keys(rows[row][item])[0]],
                unit: "мсм",
                price: rows[row][item][Object.keys(rows[row][item])[1]] || 0,
                part: rows[row][item][Object.keys(rows[row][item])[2]],
                quantity: rows[row][item][Object.keys(rows[row][item])[3]] || 0,
              };

              if (this.rented) {
                m.landlord =
                  rows[row][item][Object.keys(rows[row][item])[4]] || "";
              }

              this.mechanizations.push(m);
            }

            if (duplicates) {
              this.$snotify.warning(
                `Игнорирани са ${duplicates} повтарящи се собствени механизации`
              );
            }
          }
        };
        if (rABS) reader.readAsBinaryString(f);
        else reader.readAsArrayBuffer(f);
      } else {
        this.$snotify.error("Качените файлове трябва да бъдат .xls или .xlsx");
      }
    },
    workbookToJSON(workbook) {
      var result = {};
      workbook.SheetNames.forEach((sheetName) => {
        var roa = XLSX.utils.sheet_to_row_object_array(
          workbook.Sheets[sheetName]
        );
        if (roa.length > 0) {
          result[sheetName] = roa;
        }
      });
      return result;
    },
    filterMechanizations() {
      return this.mechanizations.filter((m) => {
        if (this.filterByPart) {
          return (
            m.name
              .toLowerCase()
              .includes(this.searchMechanizations.toLowerCase()) &&
            m.part === this.filterByPart
          );
        } else {
          return m.name
            .toLowerCase()
            .includes(this.searchMechanizations.toLowerCase());
        }
      });
    },
    updateMechanization(i) {
      this.$set(this.mechanizations, i, this.mechanizations[i]);
    },
    getAvailableParts(id) {
      let reported = this.reportedMechanizations.filter((m) => m._id === id);

      if (reported.length) {
        reported = reported.map((r) => r.part);
        return this.parts.filter((p) => reported.indexOf(p) < 0);
      }

      return this.parts;
    },
    toggleMechanizations(toggle) {
      // If searching select only results
      if (this.searchMechanizations.length) {
        const tempFilteredMechanizations = this.filterMechanizations();
        this.mechanizations.forEach((a, index) => {
          tempFilteredMechanizations.forEach((fa) => {
            if (a._id === fa._id) {
              let mechanization = a;
              if (!mechanization.isPlanned) {
                mechanization.isSelected = toggle;
              }

              this.$set(this.mechanizations, index, mechanization);
            }
          });
        });
      }
      // Otherwise select/deselect all
      else {
        this.mechanizations.forEach((a, index) => {
          let mechanization = a;
          if (!mechanization.isPlanned) {
            mechanization.isSelected = toggle;
          }
          this.$set(this.mechanizations, index, mechanization);
        });
      }
    },
    // Handle added mechanization from EditInput
    handleAdd(newMechanization) {
      // this.mechanizations.unshift(newMechanization);
      let url = `${process.env.VUE_APP_BASE_URI}/company/${this.companyId}`;
      this.$http
        .get(url)
        .then((response) => {
          const company = response.data;
          // get index of selected project
          const indexOfProject = company.projects.findIndex(
            (p) => p._id === this.projectId
          );

          const type = this.rented ? "rentedMechanizations" : "mechanizations";
          company.projects[indexOfProject][type].unshift(newMechanization);

          // make the post request
          let url = `${process.env.VUE_APP_BASE_URI}/company/${company._id}`;

          this.$http
            .put(url, company)
            .then(() => {
              this.$snotify.success("Успешно добавяне на нова механизация!");
              this.$parent.$emit(
                this.rented
                  ? "getRentedMechanizationsAgain"
                  : "getMechanizationsAgain"
              );
              this.closeEditItemWithPartModal();
            })
            .catch((error) => {
              console.log(error);
              this.$snotify.error("Нещо се обърка! Моля опитайте отново.");
            });
        })
        .catch((error) => console.log(error));
    },
    editMechanization(i) {
      this.selectedIndex = i;
      this.isEditItemWithPartOpen = true;
    },
    handleEditMechanization(m) {
      this.mechanizations[this.selectedIndex].name = m.name;
      this.mechanizations[this.selectedIndex].unit = m.unit;
      this.mechanizations[this.selectedIndex].price = m.price;
      this.mechanizations[this.selectedIndex].part = m.part;
      this.mechanizations[this.selectedIndex].updateInReports = true;
      if (this.rented) {
        this.mechanizations[this.selectedIndex].landlord = m.landlord;
      }

      this.$set(
        this.mechanizations,
        this.selectedIndex,
        this.mechanizations[this.selectedIndex]
      );
    },
    closeEditItemWithPartModal() {
      this.isEditItemWithPartOpen = false;
      this.selectedIndex = null;
    },
    deleteMechanization(i) {
      this.mechanizations.splice(i, 1);
    },
    getSelectedMechanizations() {
      return this.mechanizations.filter((a) => {
        return a.isSelected;
      });
    },
    close() {
      this.$parent.$emit(
        this.rented
          ? "closeAddRentedMechanizationsModal"
          : "closeAddMechanizationsModal"
      );
    },
    save() {
      if (this.isComingFromReport) {
        const sm = this.getSelectedMechanizations();

        for (let m of sm) {
          if (m.isSelected && !m.part) {
            return this.$snotify.error(
              "Трябва да изберете част за всяка избрана механизация"
            );
          }
        }

        this.$parent.$emit(
          this.rented
            ? "saveAddRentedMechanizationsModal"
            : "saveAddMechanizationsModal",
          sm
        );
      } else {
        this.$parent.$emit(
          this.rented
            ? "saveAddRentedMechanizationsModal"
            : "saveAddMechanizationsModal",
          this.mechanizations
        );
      }
    },
    initMechanizations() {
      const selected = [];

      if (this.newestMechanization) {
        for (let a of this.mechanizations) {
          if (a.isSelected) {
            selected.push(a._id);
          }
        }
      }

      this.mechanizations = this.$cloneDeep(this.incomingMechanizations);

      if (this.newestMechanization) {
        for (let i = 0; i < this.mechanizations.length; i++) {
          if (
            selected.indexOf(this.mechanizations[i]._id) > -1 ||
            this.mechanizations[i]._id === this.newestMechanization
          ) {
            this.mechanizations[i].isSelected = true;
          } else {
            this.mechanizations[i].isSelected = false;
          }
          this.$set(this.mechanizations, i, this.mechanizations[i]);
          this.$parent.$emit(
            this.rented
              ? "clearNewestRentedMechanization"
              : "clearNewestMechanization"
          );
        }
      }

      this.mechanizations.map((m) => {
        m.isSelected = false;
        if (typeof m.plannedItems === "number") {
          m.isPlanned = true;
        }
        if (this.isComingFromReport) {
          m.part = "";
          if (m.tasks) delete m.tasks;
        } else {
          if (!m.part) {
            m.part = "";
          }
        }
      });

      this.mechanizations.sort((x, y) => {
        return x.isSelected === y.isSelected ? 0 : x.isSelected ? -1 : 1;
      });
    },
    closeEditInputModal() {
      this.isEditInputModalOpened = false;
    },
    handleEvents(e) {
      if (e.code === "Enter") {
        // this.save();
      } else if (e.code === "Escape") {
        this.close();
      }
    },
  },
  mounted() {
    this.initMechanizations();

    if (this.toggleImport) {
      this.triggerFileInput();
    }

    window.addEventListener("keydown", this.handleEvents);
  },
  destroyed() {
    window.removeEventListener("keydown", this.handleEvents);
  },
};
</script>

<style scoped>
.model-wrapper {
  justify-content: center;
}
.desktop {
  display: initial;
}
.mobile {
  display: none;
}
.modal-content-check {
  align-items: center;
}
.modal-content-item {
  height: initial;
  padding-bottom: 5px;
  padding-top: 5px;
}
.select-p {
  border-radius: 4px;
  cursor: pointer;
  padding: 10px;
  transition: all 0.3s;
}
.select-p:hover {
  background-color: rgba(0, 0, 0, 0.1);
}
/* Responsive */
@media screen and (max-width: 1000px) {
  .modal {
    overflow: unset;
    width: 90%;
  }
  .modal-content-item {
    height: 55px;
    width: 100%;
  }
  .modal-content-check {
    margin-bottom: 5px;
    width: 100%;
  }
}
@media screen and (max-width: 700px) {
  .modal-footer {
    height: 98px;
    flex-direction: column;
  }
  .btn.btn-new {
    margin-bottom: 0.8em;
  }
  .btns-select {
    display: flex;
    justify-content: center;
    margin-top: 1em;
  }
  .btn-select {
    padding: 0 10px;
  }
}
@media screen and (max-width: 600px) {
  .desktop {
    display: none;
  }
  .mobile {
    display: initial;
  }
  .modal-header .new-input {
    width: 60%;
  }
}
@media screen and (max-width: 500px) {
  .btns {
    display: flex;
    flex-direction: column;
  }
  .btn.btn-excel {
    margin-bottom: 0.5em;
  }
}
</style>
